<template>
  <div
    v-if="isRunAndSSDPInit"
    class="layout"
    :style="{ 'padding-top': $store.state.loading ? '30px' : '0' }"
  >
    <div style="word-break: break-all;">
      <!-- 当前地址为：{{locationHref}}</div> -->
      <!-- <a-spin :spinning="true" tip="拼命加载中..."> -->
      <a-spin :spinning="$store.state.loading" tip="拼命加载中...">
        <router-view />
      </a-spin>
    </div>
  </div>
</template>
<script>
import { checkVersion } from '../tools/index.js'
// import { message, Modal } from 'ant-design-vue'
export default {
  data() {
    return {
      isRunAndSSDPInit: false,
      locationHref: ''
    }
  },
  created() {
    this.locationHref = location.href
    this.init()
  },
  methods: {
    async init() {
      await this.$nativeBridgeReady()
      await this.$request.ssdpReady()
      if (
        process.env.VUE_APP_env == 'prd' &&
        !checkVersion(this.device.appVersion, [2, 2, 0])
      ) {
        //版本控制
        // new this.$Dialog({
        //   title: '温馨提示',
        //   text: '当前版本过低，请升级',
        //   confirm: false,
        //   okText: '关闭',
        //   onOk: () => {
        //     crh.closeWebApp()
        //   }
        // })

        this.$modal.error({
          title: '温馨提示',
          content: '当前版本过低，请升级',
          okText: '关闭',
          onOk: () => {
            crh.closeWebApp()
          }
        })
        return
      }
      this.isRunAndSSDPInit = true
    }
  }
}
</script>
<style lang="scss">
.layout {
  // padding: 10rem;
  min-height: 100vh;
  -webkit-overflow-scrolling: touch;
}
</style>
